import { useState, useRef, useEffect } from 'react';
import './styles.scss';
import { Text } from '../../typography/Text/Text';

export const Modal = ({ isOpen, hasCloseBtn, onClose, children, title }) => {
  const [isModalOpen, setModalOpen] = useState(isOpen);
  const modalRef = useRef(null);

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    isModalOpen ? modalRef.current?.showModal() : modalRef.current?.close();
  }, [isModalOpen]);

  const handleCloseModal = () => {
    onClose?.();
    setModalOpen(false);
  };

  return (
    <dialog className='modal_new' ref={modalRef}>
      <div className='modal_new-header'>
        <Text semibold>{title}</Text>
        {hasCloseBtn && (
          <button className='modal_new-close' onClick={handleCloseModal}>
            <div />
            <div />
          </button>
        )}
      </div>
      {children}
    </dialog>
  );
};
